import React from "react";
import { useQuiz } from "../context/QuizContext";

export default function NextButton() {
  const { dispatch, answer, index, numQuestions } = useQuiz();

  return (
    <>
      {answer !== null &&
        (index !== numQuestions - 1 ? (
          <button
            className={"btn btn-ui"}
            onClick={() => dispatch({ type: "nextQuestion" })}
          >
            Next
          </button>
        ) : (
          <button
            className={"btn btn-ui"}
            onClick={() => dispatch({ type: "finished" })}
          >
            Finish
          </button>
        ))}
    </>
  );
}
